import { render, staticRenderFns } from "./post-add.vue?vue&type=template&id=7fc6312a&"
import script from "./post-add.vue?vue&type=script&lang=js&"
export * from "./post-add.vue?vue&type=script&lang=js&"
import style0 from "./post-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports